import React from "react";
import { Button, DialogActions } from "@mui/material";

interface IProps {
  handleCancel: () => void;
  handleConfirm: () => void;
  isDisabledActionButton: boolean;
}
const DialogActionsButtons: React.FC<IProps> = ({
  handleCancel,
  handleConfirm,
  isDisabledActionButton,
}) => {
  return (
    <DialogActions>
      <Button
        disabled={isDisabledActionButton}
        size="small"
        onClick={handleCancel}
        color="secondary"
      >
        No
      </Button>
      <Button disabled={isDisabledActionButton} size="small" onClick={handleConfirm} autoFocus>
        Yes
      </Button>
    </DialogActions>
  );
};

export default DialogActionsButtons;
